import React, { useState } from 'react';
import { getIn } from 'formik';
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import edit from "../../assets/images/edit.png";
import ImageDialog from './ImageDialogBox';

const useStyles = makeStyles(theme => ({

	bigAvatar: {
		width: 210,
		height: 130,
		borderRadius: 0
	},
	hidden: {
		display: "none"
	},
	defaultImage: {
		padding: 100,
		width: 250,
		cursor: "pointer"
	},

	posRel: {
		position: "relative"
	},
	editPen: {
		cursor: "pointer",
		width: 35,
        opacity: 1.0,
	},
	EditButton: {
		color: "grey",
		position: "absolute",
        top:"1px",
		//bottom: '1%',
		right: '0%',
		minWidth: 0,
		[theme.breakpoints.down('sm')]: {
			right: '38%',
		}
	},
	imgPic: {marginLeft: "3.2rem",paddingTop:"20px",paddingLeft:"10px",
	width: 100, height: 110, background: "#fff", textAlign: "center", display: "flex", justifyContent: "center",
    alignItems: "center", borderRadius: 6, boxShadow: "0px 24px 11px -16px rgba(0, 0, 0, 0.05)"
	},

}));
export default function ({ field, form, name, transalatorFunction, authenticatedApiCall, error, onChange, onBlur, defaultsrc}) {
	const classes = useStyles();
	const [img, setimg] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	const [open, setOpen] = React.useState(false);
	const handleEdit = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleOpenDialog = () => {
		setOpen(true);
		setAnchorEl(null);
	};

	const handleCloseDialog = (value) => {
		setOpen(false);
		if (value.file !== undefined) {
			let file = value.file;
			setimg(value.base64Rep);
			file.base64Rep = value.base64Rep;
			form.setFieldValue(field.name, file);
		}
	};
	const handleCloseDialogBox = () => {
		setOpen(false);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const blurHandler = (event) => {
		form.setFieldTouched(field.name);
		if (onBlur) {
			onBlur(event);
		}
	};
	const errorText = getIn(form.errors, field.name);
	return (
		<>
			<div className={classes.imgPic}>
				<input name={field.name} type="file" accept="image/jpeg,image/jpg,image/png" className={classes.hidden} onClick={handleOpenDialog} onBlur={blurHandler} />
					{img ? <div className={classes.posRel}><Avatar className={classes.bigAvatar} src={img} />
                    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleEdit} className={classes.EditButton}>
						<img className={classes.editPen} src={edit} /></Button>
						<Menu
							id="simple-menu"
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleClose}
						>
							<MenuItem  onClick={handleOpenDialog}>{"Edit Image"}</MenuItem>

						</Menu>
					</div> :
						field.value || field.value === "" ? <div className={classes.posRel}><Avatar className={classes.bigAvatar} src={field.value} />
							<Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleEdit} className={classes.EditButton}>
								<img className={classes.editPen} src={edit} onClick={handleEdit} /></Button>
							<Menu
								id="simple-menu"
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={handleClose}
							>
								<MenuItem  onClick={handleOpenDialog}>{"Add Image"}</MenuItem>
							</Menu>
						</div> :""}

				<ImageDialog open={open} onClose={handleCloseDialog} errorText={errorText} form={form} field={field}
                defaultsrc={defaultsrc} transalatorFunction={transalatorFunction} onCloseDialog={handleCloseDialogBox} />
			</div>
		</>
	);
}